import { render, staticRenderFns } from "./AliExpress.vue?vue&type=template&id=6590c58c&"
import script from "./AliExpress.vue?vue&type=script&lang=js&"
export * from "./AliExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports